import React from 'react'
import PublicSiderXS from '../../Layouts/Sider/PublicSiderXS'
import MobileConfirmedAppointment from './MobileConfirmedAppointment'

export default function MobileAppointmentPage ({ box, appointment, onCancel, appointmentStatus }) {
  return (
    <>
      <PublicSiderXS />
      <MobileConfirmedAppointment box={box} appointment={appointment} onCancel={onCancel} appointmentStatus={appointmentStatus} />
    </>
  )
}
